import React from "react";
import { Box } from "@chakra-ui/react";

import FaqSection from "./FaqSection";

/**
 * Homepage FAQ.
 *
 * These are the practical questions people (and AI assistants answering on
 * their behalf) ask about a clinic before booking: where it is, when it opens,
 * who treats them, what it treats. Every answer here is drawn from information
 * already published elsewhere on the site — do not add claims about pricing,
 * outcomes or availability that the clinic has not confirmed.
 */
export const HOME_FAQS = [
  {
    q: "Where is Qualiteeth Dental Care located in Jaipur?",
    a: "Qualiteeth Dental Care is at Akruti Apartments, Mahant Swami Marg, near Akshar Dham Chauraha, Vaishali Nagar, Jaipur, Rajasthan. Free parking is available at the clinic.",
  },
  {
    q: "What are the clinic timings?",
    a: "The clinic is open from 10:00 AM to 8:00 PM. You can call (+91) 92564 91206 to confirm availability or book an appointment online.",
  },
  {
    q: "Who is the dentist at Qualiteeth Dental Care?",
    a: "Treatments are led by Dr. Aishwarya Sarda, an MDS in Conservative Dentistry and Endodontics with more than 8 years of clinical experience. She is the founder of Qualiteeth Dental Care.",
  },
  {
    q: "What dental treatments does Qualiteeth Dental Care offer?",
    a: "The clinic offers root canal treatment, dental fillings, wisdom teeth removal, dental implants, braces and clear aligners, dental crowns and bridges, dentures, kids dentistry and mouth ulcer treatment.",
  },
  {
    q: "How do I book an appointment at Qualiteeth Dental Care?",
    a: "You can book online through the booking section on this website, or call the clinic directly on (+91) 92564 91206. Same-day appointments are available.",
  },
  {
    q: "Does Qualiteeth Dental Care accept dental insurance?",
    a: "The clinic provides detailed itemised bills that you can submit directly to your insurance provider for reimbursement. Call (+91) 92564 91206 with any questions about your claim.",
  },
  {
    q: "Is root canal treatment painful?",
    a: "No. Root canal treatment is carried out under local anaesthesia, so the procedure itself is painless. Most patients find the discomfort of the infection beforehand far worse than the treatment, and any soreness afterwards is usually managed with ordinary pain medication.",
  },
];

const HomeFaq = () => (
  <Box bg="#fceee5" py={{ base: 10, md: 16 }}>
    <Box maxW="4xl" mx="auto" px={4}>
      <FaqSection
        items={HOME_FAQS}
        heading="Frequently Asked Questions About Our Jaipur Dental Clinic"
      />
    </Box>
  </Box>
);

export default HomeFaq;
